import { useRef } from "react";
import MultiColumnModule from "@/components/site-builder/MultiColumnModule";
import { useMinHeightByRef } from "@/hooks/useMinHeightByRef";
import DropColumnVariant1 from "./DropColumnVariant1";
import { type DropColumnModuleType } from "./types";

interface DropColumnModuleProps {
  module: DropColumnModuleType;
}

export default function DropColumnModule(props: DropColumnModuleProps) {
  const { module } = props;
  const {
    body: { openDropColumnsInRow, buttonsAlignment },
    style: {
      display: { contentLayout },
    },
  } = module;

  const refs = useRef<HTMLDivElement[]>([]);
  const minHeight = useMinHeightByRef(refs);
  const columnCount = contentLayout.split(":").length;

  return (
    <MultiColumnModule
      module={module}
      renderBlock={(block, index) => (
        <DropColumnVariant1
          block={block}
          open={openDropColumnsInRow && index < columnCount}
          ref={(el) => {
            if (el) {
              refs.current[index] = el;
            }
          }}
          minHeight={minHeight}
          buttonsAlignment={buttonsAlignment}
        />
      )}
    />
  );
}
